import { useMutation, useQueryClient } from '@tanstack/react-query';
import { AddDictionaryEntryRequest, EmployeeDictionaryType } from '../../../models/employeeHub';
import { employeeDictionaryService } from '../services/employeeDictionaryService';
import { employeeDictionaryQueryKey } from '../../../hooks/queries/useEmployeeDictionary';

export const useAddDictionaryEntry = (type: EmployeeDictionaryType) => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: (payload: AddDictionaryEntryRequest) =>
            employeeDictionaryService.add(type, payload),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: employeeDictionaryQueryKey(type) });
        },
    });
};
